(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-dashboard"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Particle Canvas Animation
  const canvas = document.getElementById('particleCanvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];
    const particleCount = 80;

    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.vx = (Math.random() - 0.5) * 0.5;
        this.vy = (Math.random() - 0.5) * 0.5;
        this.radius = Math.random() * 2 + 1;
      }

      update() {
        this.x += this.vx;
        this.y += this.vy;

        if (this.x < 0 || this.x > canvas.width) this.vx = -this.vx;
        if (this.y < 0 || this.y > canvas.height) this.vy = -this.vy;
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(111, 159, 111, 0.3)';
        ctx.fill();
      }
    }

    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle());
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      particles.forEach(particle => {
        particle.update();
        particle.draw();
      });

      // Draw connections
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 150) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(111, 159, 111, ${0.15 * (1 - distance / 150)})`;
            ctx.lineWidth = 1;
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(animate);
    }

    animate();

    window.addEventListener('resize', function() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  }

  // Dropdown functionality
  const triggers = document.querySelectorAll('.action-mega-trigger');
  
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const card = this.closest('.action-mega-card');
      const isActive = card.classList.contains('active');
      
      // Close all dropdowns
      document.querySelectorAll('.action-mega-card').forEach(function(c) {
        c.classList.remove('active');
      });
      
      // Toggle current dropdown
      if (!isActive) {
        card.classList.add('active');
      }
    });
  });
  // Copy tracking number functionality
document.querySelectorAll('.tracking-number-copy').forEach(function(el) {
  el.addEventListener('click', function() {
    const tracking = this.getAttribute('data-tracking');
    const tooltip = this.querySelector('.copy-tooltip');
    
    navigator.clipboard.writeText(tracking).then(function() {
      tooltip.textContent = 'Copied!';
      el.classList.add('copied');
      
      setTimeout(function() {
        tooltip.textContent = 'Click to copy';
        el.classList.remove('copied');
      }, 2000);
    });
  });
});
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.action-mega-card')) {
      document.querySelectorAll('.action-mega-card').forEach(function(card) {
        card.classList.remove('active');
      });
    }
  });

  // Animated number counter
  const statValues = document.querySelectorAll('[data-count]');
  statValues.forEach(function(stat) {
    const target = parseInt(stat.getAttribute('data-count'));
    let current = 0;
    const increment = target / 50;
    const timer = setInterval(function() {
      current += increment;
      if (current >= target) {
        stat.textContent = target;
        clearInterval(timer);
      } else {
        stat.textContent = Math.floor(current);
      }
    }, 20);
  });

  // CRITICAL: Dynamic text scaling for stat values to prevent line breaks
  function scaleStatValues() {
    const statValues = document.querySelectorAll('.stat-value-autoscale');
    
    statValues.forEach(function(element) {
      const parent = element.closest('.stat-details');
      if (!parent) return;
      
      // Get available width (accounting for padding and gaps)
      const parentWidth = parent.offsetWidth - 10;
      
      // Reset to default size first
      element.style.fontSize = '40px';
      
      // Check if text overflows
      let attempts = 0;
      while (element.scrollWidth > parentWidth && attempts < 20) {
        const currentSize = parseFloat(window.getComputedStyle(element).fontSize);
        const newSize = currentSize - 2;
        
        if (newSize < 24) break; // Don't go below 24px
        
        element.style.fontSize = newSize + 'px';
        attempts++;
      }
    });
  }

  // Run scaling on load with delay to ensure proper rendering
  setTimeout(scaleStatValues, 100);
  setTimeout(scaleStatValues, 300); // Extra delay for slow loading
  
  // Run on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scaleStatValues, 100);
  });

  // Simple scroll animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  document.querySelectorAll('[data-aos]').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});
// Enhanced Order Expansion
document.querySelectorAll('.order-summary-trigger').forEach(function(trigger) {
  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    const orderItem = this.closest('.order-mega-item-enhanced');
    const isExpanded = orderItem.classList.contains('expanded');
    
    // Close all other expanded orders
    document.querySelectorAll('.order-mega-item-enhanced.expanded').forEach(function(item) {
      if (item !== orderItem) {
        item.classList.remove('expanded');
      }
    });
    
    // Toggle current order
    orderItem.classList.toggle('expanded');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();
})();
